import React, { useState, useMemo } from 'react'
import { Card, CardBody, CardFooter, Col, Form, Row } from 'reactstrap'
import { Auth } from 'aws-amplify'
import PropTypes from 'prop-types'
import Select from 'react-select'
import { Input, Button } from '../Globals'
import DASHBOARDS from '../../dashboards'
import ENTITIES from '../../entities'
import { getDealers, getMarketsByCountry } from '../../Helpers'
import { ModalInfo, ModalCode } from '../../modules'
import { useNavigate } from 'react-router-dom'

const Register = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [modalCodeIsOpen, setModalCodeIsOpen] = useState(false)
  const [username, setUsername] = useState('')
  const [error, setError] = useState('')
  const [code, setCode] = useState('')
  const navigate = useNavigate()

  const handleRedirectLogin = () => {
    navigate('/oldlogin')
  }

  const handleCloseModalInfo = () => {
    setModalIsOpen(false)
    navigate(`/oldlogin?username=${username}`)
  }

  const handleCloseModalCode = () => {
    setModalCodeIsOpen(false)
  }

  const handleSubmit = username => {
    setUsername(username)
    setModalCodeIsOpen(true)
  }

  const handleConfirmCode = () => {
    try {
      Auth.confirmSignUp(username, code).then(() => {
        setModalCodeIsOpen(false)
        setModalIsOpen(true)
      })
    } catch (e) {
      setError(e.message)
    }
  }

  return (
    <div className="app register">
      <Row>
        <Col>
          <Card className="mx-4">
            <CardBody className="p-4">
              <h1>Register</h1>
              <p className="text-muted">Create your account</p>
              <FormRegister submit={handleSubmit} />
            </CardBody>
            <CardFooter className="p-4">
              <Row>
                <Col xs="12">
                  <p className="back-login" onClick={handleRedirectLogin}>
                    Return to Login
                  </p>
                </Col>
              </Row>
            </CardFooter>
          </Card>
        </Col>
      </Row>
      <ModalInfo
        isOpen={modalIsOpen}
        close={handleCloseModalInfo}
        title="Success"
        info="Your access request has been sent for approval."
      />
      <ModalCode
        isOpen={modalCodeIsOpen}
        close={handleCloseModalCode}
        confirm={handleConfirmCode}
        code={code}
        error={error}
        change={e => setCode(e.target.value)}
      />
    </div>
  )
}

const FormRegister = props => {
  const entities = ENTITIES
  const markets = getMarketsByCountry()
  const dashboards = DASHBOARDS
  const [username, setUsername] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [repeatPassword, setRepeatPassword] = useState('')
  const [entity, setEntity] = useState({
    label: 'Select an Entity',
    value: '',
  })
  const [dealer, setDealer] = useState([])
  const [market, setMarket] = useState({ label: 'Select a Market', value: '' })
  const [dashboard, setDashboard] = useState([])
  const [dealers, setDealers] = useState([])
  const [error, setError] = useState('')

  const isDisabled = useMemo(() => {
    let _isDisbled = false

    if (!username || !email || !password || !repeatPassword || !entity.value)
      _isDisbled = true

    if (
      entity.value === 'DEALER' &&
      (dealer.value === '' || market.value === '')
    )
      _isDisbled = true

    if (entity.value === 'RBU' && market.value === '') _isDisbled = true

    if (entity.value === 'RBU' && dashboard.length === 0) _isDisbled = true

    if (password !== repeatPassword) _isDisbled = true

    return _isDisbled
  }, [
    entity,
    email,
    username,
    market,
    dealer,
    dashboard,
    password,
    repeatPassword,
  ])

  const handleSubmit = async e => {
    e.preventDefault()

    let attributes = {
      email,
      'custom:entity': entity.value,
      'custom:isValidated': '0',
    }

    if (dealer.length > 0) {
      let dealerStr = ''
      for (let i = 0; i < dealer.length; i++)
        dealerStr += dealer[i + 1] ? `${dealer[i].value};` : dealer[i].value

      attributes['custom:entityId'] = dealerStr
    }

    if (market.value) attributes['custom:market'] = market.value

    if (dashboard.length > 0) {
      attributes['custom:dashboard'] = ''
      for (let i = 0; i < dashboard.length; i++) {
        if (i === dashboard.length - 1)
          attributes['custom:dashboard'] += dashboard[i].value
        else attributes['custom:dashboard'] += `${dashboard[i].value} / `
      }
    } else {
      if (entity.value === 'DEALER') {
        attributes[
          'custom:dashboard'
        ] = `${dashboards[0].value} / ${dashboards[1].value}`
      } else if (entity.value === 'CMM') {
        attributes['custom:dashboard'] = dashboards[3].value
      } else if (entity.value === 'CRO') {
        attributes['custom:dashboard'] = dashboards[0].value
      } else if (entity.value === 'CEC') {
        attributes[
          'custom:dashboard'
        ] = `${dashboards[2].value} / ${dashboards[3].value} / ${dashboards[4].value}`
      }
    }

    const userData = { username, password, attributes }

    try {
      await Auth.signUp(userData)
      props.submit(username)
    } catch (e) {
      setError(e.message)
    }
  }

  const handleChangeMarket = async market => {
    if (entity.value === 'DEALER') {
      try {
        const { dealers, error } = await getDealers(market.value)
        setDealers(dealers)
        setDealer([])
        setError(error)
        setMarket(market)
      } catch (e) {
        setError(e.message)
      }
    } else {
      setMarket(market)
    }
  }

  const handleChangeEntity = entity => {
    setMarket({ label: 'Select a Market', value: '' })
    if (entity.value.includes('RBU') || entity.value.includes('DEALER')) {
      setMarket(markets[0])
    }
    setEntity(entity)
  }

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col md="6">
          <Input
            required
            icon="fa fa-user"
            type="text"
            label="username"
            name="username"
            placeHolder="Username"
            value={username}
            change={username => setUsername(username)}
          />
          <Input
            required
            icon="fa fa-envelope"
            type="email"
            label="email"
            name="email"
            placeHolder="Email"
            value={email}
            change={email => setEmail(email)}
          />
          <Input
            required
            icon="fa fa-lock"
            type="password"
            label="password"
            name="password"
            placeHolder="Password"
            value={password}
            change={password => setPassword(password)}
          />
          <Input
            required
            icon="fa fa-lock"
            type="password"
            label="repeat password"
            name="repeatPassword"
            placeHolder="Repeat password"
            noPaste={true}
            value={repeatPassword}
            change={repeatPassword => setRepeatPassword(repeatPassword)}
            paste={e => {
              e.preventDefault()
              return false
            }}
          />
        </Col>
        <Col md="6">
          <div className="form-register-content">
            <label>Entity</label>
            <Select
              value={entity}
              onChange={entity => handleChangeEntity(entity)}
              options={entities}
              isSearchable={true}
              className="select-custom select-entity"
              classNamePrefix="select-custom"
            />
          </div>
          {(entity.value === 'RBU' ||
            entity.value === 'DEALER' ||
            entity.value === 'ADMIN_RBU' ||
            entity.value === 'ADMIN_DEALER') && (
            <div className="form-register-content">
              <label>Market</label>
              <Select
                value={market}
                onChange={handleChangeMarket}
                options={markets}
                isSearchable={true}
                className="select-custom select-entity"
                classNamePrefix="select-custom"
              />
            </div>
          )}
          {entity.value === 'RBU' && (
            <div className="form-register-content">
              <label>Dashboard</label>
              <Select
                value={dashboard}
                onChange={dashboard => setDashboard(dashboard)}
                options={dashboards}
                isSearchable={true}
                className="select-custom select-entity"
                classNamePrefix="select-custom"
                placeholder="Select a dashboard"
                isMulti={true}
              />
            </div>
          )}
          {entity.value === 'DEALER' && (
            <div className="form-register-content">
              <label>Dealer</label>
              <Select
                value={dealer}
                onChange={dealer => setDealer(dealer)}
                options={dealers}
                isSearchable={true}
                className="select-custom select-entity"
                classNamePrefix="select-custom"
                placeholder="Select a dealer"
                isMulti={true}
              />
            </div>
          )}
        </Col>
      </Row>
      {error && <p className="error">{error}</p>}
      <div className="btn-create">
        <Button
          disabled={isDisabled}
          class="btn-nissan-red"
          type="submit"
          text="Create Account"
        />
      </div>
    </Form>
  )
}

FormRegister.propTypes = {
  submit: PropTypes.func.isRequired,
}

export default Register
